<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-sm-2 pa-0 mx-auto">
            <v-flex xs12 class="text-left">
                <v-btn text color="warning" :to="{ name: 'teamsList' }" class="ma-0 mb-2"><v-icon left>arrow_back</v-icon> All Teams</v-btn>

                <v-overlay :absolute="true" :value="overlay" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlay = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <v-overlay :absolute="true" :value="overlaytemp" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlaytemp = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <v-overlay :absolute="true" :value="overlayforfeit" z-index="99" opacity="0.56">
                    <v-card>
                        <v-card-text v-html="overlayText"></v-card-text>
                        <v-card-actions>
                            <v-btn medium block dark :color="overlayColor" @click="overlayforfeit = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-overlay>

                <div v-if="teamLoaded && viewTeam" v-cloak>
                    <h1 class="grey--text lighten-3 d-inline-block">Team: {{ teamDetail.t_name ?? '' }}</h1>

                    <v-dialog v-model="forfeit_dialog" max-width="900" @click:outside="forfeit_dialog = false;">
                        <v-overlay :absolute="true" :value="overlayforfeitnew" z-index="99" opacity="0.56">
                            <v-card>
                                <v-card-text v-html="overlayText"></v-card-text>
                                <v-card-actions>
                                    <v-btn medium block dark :color="overlayColor" @click="overlayforfeitnew = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-overlay>

                        <v-card>
                            <v-card-title class="text-h5">
                            Forfeit Game
                            </v-card-title>

                            <v-card-text>
                                <v-layout row wrap align-start class="pa-2">
                                    <v-flex xs12 sm12 md12>
                                        <p class="text-h6 error--text ma-0 my-2">Please note once submitted, you can not reverse a forfeit notification. Please check Competition by-laws for penalties before submitting - <a href="/about/policy-procedures/" target="_blank">Policy procedures</a></p>
                                        <v-select
                                            prepend-icon="event"
                                            :items="gameselect"
                                            label="Forfeit Game*"
                                            v-model.lazy.trim="forfeitgame"
                                            v-validate="'required'"
                                            :error="errors.has('forfeitgame')"
                                            :error-messages="errors.collect('forfeitgame')"
                                            :name="'forfeitgame'"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="warning" text @click="forfeit_dialog = false;">Cancel</v-btn>
                                <v-btn :disabled="teamLoading" :loading="teamLoading" color="error" @click="sendGameForfeit">Forfeit</v-btn>
                            </v-card-actions>
                            </v-card>
                    </v-dialog>

                    <v-card class="mt-2">
                        <v-container container--fluid grid-list-lg class="pa-0">
                            <v-layout row wrap class="pa-sm-2 pa-0 ma-0">
                                <v-flex xs12 class="pa-sm-2 pa-0" v-cloak v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">settings_applications</v-icon>Team Features</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text features">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">Save</div>
                                                <div class="Ftable__item text-left">Forfeit</div>
                                                <div class="Ftable__item text-left">Team Roster</div>
                                                <div class="Ftable__item text-left">Temporary Roster</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left bottom-border">
                                                    <v-btn v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" @click="saveTeam" class="col-12" color="secondary"><v-icon left color="white" style="margin-right: 6px;">save</v-icon> SAVE</v-btn>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <v-btn class="col-12" color="error" elevation="2" @click="forfeitTeam" v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)"><v-icon left color="white" style="margin-right: 6px;">sports</v-icon> FORFEIT</v-btn>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <v-btn class="col-12" v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" @click.stop="addPlayersDialog" outlined color="secondary"><v-icon left color="secondary" style="margin-right: 6px;">person_add</v-icon> Add Team Member</v-btn>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <v-btn class="col-12" v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" @click.stop="addTempPlayersDialog" color="info" outlined><v-icon left color="info" style="margin-right: 6px;">add_link</v-icon> Add Temporary Member</v-btn>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 class="pa-sm-2 pa-0 mt-4">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">group_work</v-icon>Team Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">Division</div>
                                                <div class="Ftable__item text-left">Season</div>
                                                <div class="Ftable__item text-left">Uniform  - Singlet Colour</div>
                                                <div class="Ftable__item text-left">Uniform  - Number Colour</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ teamDetail.t_division | capitalize }}</span>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ teamDetail.t_season | capitalize }}</span>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <p class="text-body-2 font-weight-bold text-center red--text" v-if="!singletColour"><v-icon style="margin-top: -3px;" color="red" left small>info</v-icon>COLOUR NOT SELECTED</p>
                                                    <v-text-field v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="mt-4" v-model="singletColour" label="Pick colour for Singlet" dense type="color" prepend-icon="palette"></v-text-field>
                                                    <span v-if="!(isManager || isTeamAdmin) || teamDetail.t_season_archived || !teamDetail.t_season_status  || !teamDetail.t_division_status"><span :style="`margin: 0 auto;display: block;width: 100%; height: 30px;background-color: ${singletColour};`"></span></span>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <p class="text-body-2 font-weight-bold text-center red--text" v-if="!numberColour"><v-icon style="margin-top: -3px;" color="red" left small>info</v-icon>COLOUR NOT SELECTED</p>
                                                    <v-text-field v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="mt-4" v-model="numberColour" label="Pick colour for Number" dense type="color" prepend-icon="palette"></v-text-field>
                                                    <span v-if="!(isManager || isTeamAdmin) || teamDetail.t_season_archived || !teamDetail.t_season_status || !teamDetail.t_division_status"><span :style="`margin: 0 auto;display: block;width: 100%; height: 30px;background-color: ${numberColour};`"></span></span>
                                                </div>
                                            </div>
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">Position(s)</div>
                                                <div class="Ftable__item text-left">Manager / Admin / Coach / Assistant</div>
                                                <!-- <div class="Ftable__item text-left">Coach</div> -->
                                                <div class="Ftable__item text-left">Final Series Qualification (%)</div>
                                            </div>
                                            <div class="Ftable__row">
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ teamDetail.t_function }}</span>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span class="d-block" v-if="teamLoaded && teamDetail.t_manager">{{ 'M: ' + teamDetail.t_manager | capitalize }}</span>
                                                    <span class="d-block" v-if="teamLoaded && teamDetail.t_admin">{{ 'A: ' + teamDetail.t_admin | capitalize }}</span>
                                                    <span class="d-block" v-if="teamLoaded && teamDetail.t_coach">{{ 'C: ' + teamDetail.t_coach | capitalize }} <v-btn  v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" icon ripple @click.native="deletePosition('coach')" ><v-icon class="red--text text--lighten-1">delete</v-icon></v-btn></span>
                                                    <span class="d-block" v-if="teamLoaded && teamDetail.t_assistant">{{ 'Asst: ' + teamDetail.t_assistant | capitalize }} <v-btn  v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" icon ripple @click.native="deletePosition('assistant')" ><v-icon class="red--text text--lighten-1">delete</v-icon></v-btn></span>
                                                </div>
                                                <!-- <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ teamDetail.t_coach | capitalize }}</span>
                                                </div> -->
                                                <div class="Ftable__item text-left bottom-border">
                                                    <span>{{ teamDetail.t_division_qual | capitalize }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-flex>

                               <v-flex xs12 class="pa-sm-2 pa-0 mt-4">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title class="d-block">
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">perm_identity</v-icon>Players Information</div>
                                            </div>
                                            <div class="mob_only pt-2"><em>Rotate your phone landscape for better experience<br>to display members information</em></div>
                                        </v-card-title>

                                        <v-dialog v-model="add_dialog" max-width="900" @click:outside="emptyNewPlayers">
                                            <v-overlay :absolute="true" :value="overlaynew" z-index="99" opacity="0.56">
                                                <v-card>
                                                    <v-card-text v-html="overlayText"></v-card-text>
                                                    <v-card-actions>
                                                        <v-btn medium block dark :color="overlayColor" @click="overlaynew = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-overlay>

                                            <v-card>
                                                <v-card-title class="text-h5">
                                                Add New Member Request
                                                </v-card-title>

                                                <v-card-text>
                                                    <div v-for="(newplayer, index_newplayer) in newplayers" :key="index_newplayer">
                                                        <v-layout row wrap align-start class="pa-2">
                                                            <v-flex xs12 sm12 md12>
                                                                New Member #{{ index_newplayer + 1 }}
                                                                <span v-if="newplayer.click && newplayer.confirm">
                                                                    Added - {{ newplayer.firstname }} {{ newplayer.lastname }}
                                                                    <v-btn color="error" small outlined @click="removeNewPlayer(index_newplayer)" class="my-3 my-sm-0 mx-sm-6 mx-0 mob-block"
                                                                        ><v-icon dark small left>remove_circle</v-icon> Remove new member</v-btn
                                                                    ></span
                                                                >
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row wrap align-start  class="pa-0" v-if="!(newplayer.click && newplayer.confirm)">
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    prepend-icon="person"
                                                                    label="Firstname*"
                                                                    v-model.lazy.trim="newplayer.firstname"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newplayer.firstname_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.firstname_' + index_newplayer)"
                                                                    :name="'newplayer.firstname_' + index_newplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    prepend-icon="person"
                                                                    label="Lastname*"
                                                                    v-model.lazy.trim="newplayer.lastname"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newplayer.lastname_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.lastname_' + index_newplayer)"
                                                                    :name="'newplayer.lastname_' + index_newplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newplayer.copied">
                                                                <v-select
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    prepend-icon="perm_identity"
                                                                    :items="gender"
                                                                    label="Gender*"
                                                                    v-model.lazy.trim="newplayer.gender"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newplayer.gender_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.gender_' + index_newplayer)"
                                                                    :name="'newplayer.gender_' + index_newplayer"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newplayer.copied">
                                                                <v-text-field
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    prepend-icon="event"
                                                                    v-mask="'##/##/####'"
                                                                    hint="dd/mm/yyyy"
                                                                    persistent-hint
                                                                    label="Date of Birth*"
                                                                    v-model.lazy.trim="newplayer.dob"
                                                                    v-validate="'required|date_format:dd/MM/yyyy'"
                                                                    :error="errors.has('newplayer.dob_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.dob_' + index_newplayer)"
                                                                    :name="'newplayer.dob_' + index_newplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newplayer.copied">
                                                                <v-select
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    prepend-icon="badge"
                                                                    :items="role"
                                                                    label="Role*"
                                                                    v-model.lazy.trim="newplayer.role"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newplayer.role_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.role_' + index_newplayer)"
                                                                    :name="'newplayer.role_' + index_newplayer"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="newplayer.requireEmail && !newplayer.copied">
                                                                <v-text-field
                                                                    :disabled="newplayer.confirm || newplayer.copied"
                                                                    label="Email*"
                                                                    prepend-icon="email"
                                                                    v-model.lazy.trim="newplayer.email"
                                                                    v-validate="'email|required'"
                                                                    :error="errors.has('newplayer.email_' + index_newplayer)"
                                                                    :error-messages="errors.collect('newplayer.email_' + index_newplayer)"
                                                                    :name="'newplayer.email_' + index_newplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12 class="text-left"></v-flex>
                                                            <v-flex xs12 sm6 md6 class="text-left">
                                                                <v-btn
                                                                    :color="!newplayer.confirm && newplayer.click ? 'red white--text' : 'success white--text'"
                                                                    :disabled="newplayer.click && newplayer.confirm"
                                                                    small
                                                                    @click="checkNewPlayer(index_newplayer)"
                                                                    class="mt-3 mb-1 mx-0 mob-block"
                                                                    v-model.lazy.trim="newplayer.click"
                                                                    v-validate="'required:true'"
                                                                    :error="errors.has('newplayer.click_' + index_newplayer)"
                                                                    :name="'newplayer.click_' + index_newplayer"
                                                                    ><v-icon dark small left>{{ newplayer.click && newplayer.confirm ? "how_to_reg" : "person_add" }}</v-icon
                                                                    >{{ newplayer.btn }}</v-btn
                                                                >
                                                                <span class="caption red--text text--darken-1 d-block" v-if="newplayer.status && newplayer.status != 'New Player Found'">{{ newplayer.status }}</span>
                                                                <span v-if="errors.has('newplayer.click_' + index_newplayer)" class="caption red--text text--darken-1 d-block">Must click "ADD New Member" button</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 class="text-right">
                                                                <v-btn
                                                                    color="error"
                                                                    small
                                                                    outlined
                                                                    @click="removeNewPlayer(index_newplayer)"
                                                                    class="mt-3 mb-1 mx-0 mob-block"
                                                                    ><v-icon dark small left>remove_circle</v-icon> Remove New Member</v-btn
                                                                >
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider light class="my-3"></v-divider>
                                                    </div>
                                                    <v-btn color="secondary" small @click="addNewPlayer"><v-icon dark small left>add_circle</v-icon>ADD NEW MEMBER</v-btn>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="warning" text @click="emptyNewPlayers">Cancel</v-btn>
                                                    <v-btn color="primary" @click="sendNewPlayers">SEND</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>

                                        <v-dialog v-model="add_tempdialog" max-width="900" @click:outside="emptyNewTempPlayers">
                                            <v-overlay :absolute="true" :value="overlaynewtemp" z-index="99" opacity="0.56">
                                                <v-card>
                                                    <v-card-text v-html="overlayText"></v-card-text>
                                                    <v-card-actions>
                                                        <v-btn medium block dark :color="overlayColor" @click="overlaynewtemp = false">Close <v-icon medium right>highlight_off</v-icon> </v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-overlay>

                                            <v-card>
                                                <v-card-title class="text-h5">
                                                Add Temporary Member Request
                                                </v-card-title>

                                                <v-card-text>
                                                    <div v-for="(newtempplayer, index_newtempplayer) in newtempplayers" :key="index_newtempplayer">
                                                        <v-layout row wrap align-start class="pa-2">
                                                            <v-flex xs12 sm12 md12>
                                                                Temporary Member #{{ index_newtempplayer + 1 }}
                                                                <span v-if="newtempplayer.click && newtempplayer.confirm">
                                                                    Added - {{ newtempplayer.firstname }} {{ newtempplayer.lastname }}
                                                                    <v-btn color="error" small outlined @click="removeNewTempPlayer(index_newtempplayer)" class="my-3 my-sm-0 mx-sm-6 mx-0 mob-block"
                                                                        ><v-icon dark small left>remove_circle</v-icon> Remove temporary member</v-btn
                                                                    ></span
                                                                >
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row wrap align-start  class="pa-0" v-if="!(newtempplayer.click && newtempplayer.confirm)">
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="person"
                                                                    label="Firstname*"
                                                                    v-model.lazy.trim="newtempplayer.firstname"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newtempplayer.firstname_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.firstname_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.firstname_' + index_newtempplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="person"
                                                                    label="Lastname*"
                                                                    v-model.lazy.trim="newtempplayer.lastname"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newtempplayer.lastname_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.lastname_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.lastname_' + index_newtempplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newtempplayer.copied">
                                                                <v-select
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="perm_identity"
                                                                    :items="gender"
                                                                    label="Gender*"
                                                                    v-model.lazy.trim="newtempplayer.gender"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newtempplayer.gender_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.gender_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.gender_' + index_newtempplayer"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newtempplayer.copied">
                                                                <v-text-field
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="event"
                                                                    v-mask="'##/##/####'"
                                                                    hint="dd/mm/yyyy"
                                                                    persistent-hint
                                                                    label="Date of Birth*"
                                                                    v-model.lazy.trim="newtempplayer.dob"
                                                                    v-validate="'required|date_format:dd/MM/yyyy'"
                                                                    :error="errors.has('newtempplayer.dob_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.dob_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.dob_' + index_newtempplayer"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newtempplayer.copied">
                                                                <v-select
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="event"
                                                                    :items="gameselect"
                                                                    label="Game*"
                                                                    v-model.lazy.trim="newtempplayer.game"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newtempplayer.game_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.game_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.game_' + index_newtempplayer"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="!newtempplayer.copied">
                                                                <v-select
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    prepend-icon="transfer_within_a_station"
                                                                    :items="teamplayers"
                                                                    item-value="mid"
                                                                    item-text="fullname"
                                                                    label="Team Roster*"
                                                                    hint="temporary player will be replacing"
                                                                    persistent-hint
                                                                    v-model.lazy.trim="newtempplayer.replacing"
                                                                    v-validate="'required'"
                                                                    :error="errors.has('newtempplayer.replacing_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.replacing_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.replacing_' + index_newtempplayer"
                                                                ></v-select>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12 v-if="newtempplayer.requireEmail && !newtempplayer.copied">
                                                                <p class="subtitle-2 red--text">This temporary member cannot be added. Wrong Member Information. Please contact us for further details.</p>
                                                                <!-- <v-text-field
                                                                    :disabled="newtempplayer.confirm || newtempplayer.copied"
                                                                    label="Email*"
                                                                    prepend-icon="email"
                                                                    v-model.lazy.trim="newtempplayer.email"
                                                                    v-validate="'email|required'"
                                                                    :error="errors.has('newtempplayer.email_' + index_newtempplayer)"
                                                                    :error-messages="errors.collect('newtempplayer.email_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.email_' + index_newtempplayer"
                                                                ></v-text-field> -->
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12></v-flex>
                                                            <v-flex xs12 sm6 md6 class="text-left mb-2">
                                                                <v-btn
                                                                    :color="!newtempplayer.confirm && newtempplayer.click ? 'red white--text' : 'success white--text'"
                                                                    :disabled="newtempplayer.click && newtempplayer.confirm"
                                                                    small
                                                                    @click="checkNewTempPlayer(index_newtempplayer)"
                                                                    class="mt-3 mb-1 mx-0 mob-block"
                                                                    v-model.lazy.trim="newtempplayer.click"
                                                                    v-validate="'required:true'"
                                                                    :error="errors.has('newtempplayer.click_' + index_newtempplayer)"
                                                                    :name="'newtempplayer.click_' + index_newtempplayer"
                                                                    ><v-icon dark small left>{{ newtempplayer.click && newtempplayer.confirm ? "how_to_reg" : "person_add" }}</v-icon
                                                                    >{{ newtempplayer.btn }}</v-btn
                                                                >
                                                                <!-- <span class="caption red--text text--darken-1 d-block" v-if="newtempplayer.status && newtempplayer.status != 'New Player Found'">{{ newtempplayer.status }}</span> -->
                                                                <span v-if="errors.has('newtempplayer.click_' + index_newtempplayer)" class="caption red--text text--darken-1 d-block">Must click "ADD Temporary Member" button</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 class="text-right">
                                                                <v-btn
                                                                    color="error"
                                                                    small
                                                                    outlined
                                                                    @click="removeNewTempPlayer(index_newtempplayer)"
                                                                    class="mt-3 mb-1 mx-0 mob-block"
                                                                    ><v-icon dark small left>remove_circle</v-icon> Remove Temporary Member</v-btn
                                                                >
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-divider light class="my-3"></v-divider>
                                                    </div>
                                                    <v-btn color="secondary" small @click="addNewTempPlayer"><v-icon dark small left>add_circle</v-icon>ADD TEMPORARY MEMBER</v-btn>
                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="warning" text @click="emptyNewTempPlayers">Cancel</v-btn>
                                                    <v-btn color="primary" @click="sendNewTempPlayers">SEND TEMPORARY MEMBERS</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        <div class="Ftable black--text">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left" style="max-width: 130px;">Playing Number</div>
                                                <div class="Ftable__item text-left">Lastname</div>
                                                <div class="Ftable__item text-left">Firstname</div>
                                                <div class="Ftable__item text-left" v-if="!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status">Attendance (%)</div>
                                                <div class="Ftable__item text-left" v-if="!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status">Registration expiry</div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-lext">Email</div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-lext">DOB</div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-lext">Mobile</div>
                                            </div>
                                            <div class="Ftable__row" v-for="player in teamDetail.t_players" :key="player.mid">
                                                <div class="Ftable__item text-left bottom-border" style="max-width: 130px;">
                                                    <v-text-field v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" :value="getPlayersNumber(player.mid)" @input="playingNumber($event, player.mid)" class="playerNumber" single-line dense outlined type="text" min="0" max="100" v-mask="'###'" prepend-icon="tag"></v-text-field>
                                                    <span v-if="!(isManager || isTeamAdmin) || teamDetail.t_season_archived || !teamDetail.t_season_status || !teamDetail.t_division_status">{{getPlayersNumber(player.mid)}}</span>
                                                </div>
                                                <div class="Ftable__item text-left bottom-border"><v-btn  v-if="(isManager || isTeamAdmin) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" icon ripple @click.native="deletePlayer(player)" ><v-icon class="red--text text--lighten-1">delete</v-icon></v-btn> <span>{{ player.lastname | capitalize }}</span></div>
                                                <div class="Ftable__item text-left bottom-border"><span>{{ player.firstname | capitalize }}</span></div>
                                                <div class="Ftable__item text-left bottom-border" v-if="!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status"><span>{{ player.attendance }}</span></div>
                                                <div class="Ftable__item text-left bottom-border" v-if="!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status"><span>{{ player.expiry }}</span></div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-left bottom-border"><a target="_blank" :href="`mailto:${player.email}`"><span>{{ player.email }}</span></a></div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-left bottom-border"><span>{{ player.dob }}</span></div>
                                                <div v-if="(isManager || isTeamAdmin || isCoach) && (!teamDetail.t_season_archived && teamDetail.t_season_status && teamDetail.t_division_status)" class="Ftable__item text-left bottom-border"><a target="_blank" :href="`tel:${player.mobile}`"><span>{{ player.mobile }}</span></a></div>
                                            </div>

                                            <v-dialog v-model="remove_dialog" max-width="600">
                                                <v-card>
                                                    <v-card-title class="text-h5">Remove Member</v-card-title>
                                                    <v-card-text>
                                                        <p>It will immediately remove the following member from the team, are you sure?</p>
                                                        <p class="font-weight-bold">{{remove_player.lastname}} {{remove_player.firstname}}</p>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="warning" text @click="cancelRemovePlayer">Cancel</v-btn>
                                                        <v-btn color="error" @click="sendRemovePlayer(remove_player)">Remove</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>

                                            <v-dialog v-model="remove_position_dialog" max-width="600">
                                                <v-card>
                                                    <v-card-title class="text-h5">Remove Position</v-card-title>
                                                    <v-card-text>
                                                        <p>It will immediately remove the following position from the team, are you sure?</p>
                                                        <p class="font-weight-bold">{{remove_position|capitalize}}: {{remove_position_fullname}}</p>
                                                    </v-card-text>

                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="warning" text @click="cancelRemovePosition">Cancel</v-btn>
                                                        <v-btn color="error" @click="sendRemovePosition(remove_position)">Remove</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                        </div>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 v-if="hasInvoices">
                                    <v-card color="blue-grey darken-2" class="white--text">
                                        <v-card-title primary-title>
                                            <div>
                                                <div class="headline"><v-icon medium left color="white">assignment</v-icon>Invoice Information</div>
                                            </div>
                                        </v-card-title>

                                        <div class="Ftable black--text">
                                            <div class="Ftable__row Ftable__header">
                                                <div class="Ftable__item text-left">#</div>
                                                <div class="Ftable__item text-left">Due Date</div>
                                                <div class="Ftable__item text-left">Fully Paid - Amount owing</div>
                                                <div class="Ftable__item text-right">Total amount</div>
                                            </div>
                                            <v-expansion-panels accordion flat class="exp-panel">
                                                <v-expansion-panel v-for="invoice in teamDetail.t_invoices" :key="invoice.inv_id">
                                                    <v-expansion-panel-header class="pa-0">
                                                        <div class="Ftable__row">
                                                            <div class="Ftable__item text-left bottom-border">
                                                                <span class="toggle_exp_btn"
                                                                    ><i aria-hidden="true" class="v-icon material-icons theme--light">keyboard_arrow_down</i
                                                                    >{{ invoice.inv_id }}</span
                                                                >
                                                            </div>
                                                            <div class="Ftable__item text-left bottom-border">
                                                                <span>{{ invoice.inv_due_date }}</span>
                                                            </div>
                                                            <div class="Ftable__item text-left">
                                                                <span>{{ invoice.inv_paid }}</span
                                                                ><span v-if="invoice.inv_paid == 'No'"> - {{ owingPayments(invoice.inv_amount, invoice.inv_payments) }}</span>
                                                                <!--//v-btn small :to="{name: 'invoice', params: {invoice_id: invoice.inv_id}}" v-if="invoice.inv_paid == 'No'" outlined color="indigo"><v-icon small left color="indigo" style="margin-right: 6px;">add_circle</v-icon> PAYMENT</v-btn//-->
                                                            </div>
                                                            <div class="Ftable__item text-right">
                                                                <span>{{ invoice.inv_amount | currency }}</span>
                                                            </div>
                                                        </div>
                                                    </v-expansion-panel-header>
                                                    <v-expansion-panel-content>
                                                        <v-card>
                                                            <v-card-text>
                                                                <div v-if="invoice.inv_payments.length">
                                                                    <div class="Ftable__row Ftable__header">
                                                                        <div class="Ftable__item text-left">Fullname</div>
                                                                        <div class="Ftable__item text-left">Date</div>
                                                                        <div class="Ftable__item text-right">Amount paid</div>
                                                                    </div>
                                                                    <div class="Ftable__row" v-for="payment in invoice.inv_payments" :key="payment.pid">
                                                                        <div class="Ftable__item text-left bottom-border">
                                                                            <span>{{ payment.p_member | capitalize }}</span>
                                                                        </div>
                                                                        <div class="Ftable__item text-left bottom-border">
                                                                            <span>{{ payment.p_date }}</span>
                                                                        </div>
                                                                        <div class="Ftable__item text-right bottom-border">
                                                                            <span>{{ displayAmount(payment) | currency }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="Ftable__row Ftable__header">
                                                                        <div class="Ftable__item cols-3 text-right">
                                                                            Total amount paid: {{ totalPayments(invoice.inv_payments) }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="invoice.inv_payments.length == 0">
                                                                    <div class="text-center">No Payments Yet!</div>
                                                                </div>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-expansion-panels>
                                        </div>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </div>

                <div class="justify-center align-center layout" v-if="!teamLoaded && !viewTeam"><v-icon left medium>warning</v-icon> No Team Data"</div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
import moment from "moment";

export default {
    name: "TeamDetailModule",
    components: {
        //
    },
    props: {
        "team-tid": {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            newplayers: [],
            newtempplayers: [],
            teamplayers: [],
            gender: [{ text: "Male", value: "male" }, { text: "Female", value: "female" }],
            role: [{ text: "Member", value: "player" }, { text: "Coach (swap)", value: "coach" }, { text: "Assistant (swap)", value: "assistant" }],
            gameselect: [],
            forfeitgame: '',
            teamDetail: {},
            teamLoaded: false,
            viewTeam: true,
            moment: moment,
            overlay: false,
            overlaytemp: false,
            overlaynew: false,
            overlaynewtemp: false,
            overlayforfeit: false,
            overlayforfeitnew: false,
            add_dialog: false,
            add_tempdialog: false,
            forfeit_dialog: false,
            remove_dialog: false,
            remove_position_dialog: false,
            remove_position: '',
            remove_position_fullname: '',
            remove_player: {mid: '', lastname: '', firstname: ''},
            timeout: 2000,
            overlayText: "",
            overlayColor: "primary",
            singletColour: '',
            numberColour: '',
            playersNumber: {},

            dictionary: {
                messages: {
                    required: () => "This field is required",
                    email: () => "This field must be a valid email",
                    date_format: () => "This field must be a valid date",
                    numeric: () => "This field is number only",
                },
            },
        };
    },
    computed: {
        user() {
            return this.$store.getters["user/getProfile"];
        },
        teams() {
            return this.$store.getters["team/teams"];
        },
        team() {
            return this.$store.getters["team/teamDetailById"](this.teamTid);
        },
        hasInvoices() {
            return !_.isEmpty(this.teamDetail.t_invoices);
        },
        isManager() {
            if(_.includes(_.toLower(this.teamDetail.t_function), 'manager') && this.teamDetail.t_manager == this.user.firstname + ' ' + this.user.lastname){
                return true;
            }

            return false;
        },
        isTeamAdmin() {
            if(_.includes(_.toLower(this.teamDetail.t_function), 'admin') && this.teamDetail.t_admin == this.user.firstname + ' ' + this.user.lastname){
                return true;
            }

            return false;
        },
        isCoach() {
            if(_.includes(_.toLower(this.teamDetail.t_function), 'coach') && this.teamDetail.t_coach == this.user.firstname + ' ' + this.user.lastname){
                return true;
            }

            return false;
        },
        teamLoading() {
            return this.$store.getters["team/teamStatus"] == "loading";
        },
    },
    watch: {
        teams(n, o) {
            let teamId = this.teamTid;
            this.teamDetail = _.find(n, function(tm) {
                return tm.t_id == teamId;
            });

            if (_.isEmpty(this.teamDetail) && this.team === undefined) {
                this.teamLoaded = false;
                this.viewTeam = false;
            } else {
                this.singletColour = this.teamDetail.t_singlet_colour;
                this.numberColour = this.teamDetail.t_number_colour;

                let playersNumberArr = [];
                let teamplayers = [{ fullname: "Not Applicable", mid: "" }];
                _.forEach(this.teamDetail.t_players, function(player) {
                    playersNumberArr[player.mid] = player.playing_number;
                    teamplayers.push({'mid': player.mid, 'fullname': player.lastname + ' ' + player.firstname});
                });
                this.playersNumber = playersNumberArr;
                this.teamplayers = teamplayers;
                // console.log('refreshed 2nd loaded');
            }
        },
        team() {
            this.teamDetail = this.team;
            this.singletColour = this.teamDetail.t_singlet_colour;
            this.numberColour = this.teamDetail.t_number_colour;

            let playersNumberArr = [];
            let teamplayers = [{ fullname: "Not Applicable", mid: "" }];
            _.forEach(this.teamDetail.t_players, function(player) {
                playersNumberArr[player.mid] = player.playing_number;
                teamplayers.push({'mid': player.mid, 'fullname': player.lastname + ' ' + player.firstname});
            });
            this.playersNumber = playersNumberArr;
            this.teamplayers = teamplayers;
            // console.log('last loaded');
        },
    },
    methods: {
        forfeitTeam: function(){
            this.$store.dispatch("team/gameRequest", {teamTid: this.teamTid}).then(games => {
                this.gameselect = games;
                this.forfeit_dialog = true;
            }).catch(err => {
                this.overlayforfeit = true;
                this.overlayColor = "error";
                this.overlayText = "Error team games.";

                setTimeout(() => {
                    this.overlayforfeit = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        addPlayersDialog: function(){
            if(_.size(this.teamDetail.t_players) >= this.teamDetail.t_division_max_players){
                this.overlay = true;
                this.overlayColor = "error";
                this.overlayText = "Cannot add members to team";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            } else {
                this.add_dialog = true;
            }
        },
        addTempPlayersDialog: function(){
            //get next games for team
            this.$store.dispatch("team/gameRequest", {teamTid: this.teamTid}).then(games => {
                this.gameselect = games;
                this.add_tempdialog = true;
            }).catch(err => {
                //@TODO replace
                this.gameselect = [];
                this.add_tempdialog = true;
                // this.overlaytemp = true;
                // this.overlayColor = "error";
                // this.overlayText = "Error team games.";

                setTimeout(() => {
                    this.overlaytemp = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        deletePlayer: function(player) {
            if(_.size(this.teamDetail.t_players) <= this.teamDetail.t_division_min_players){
                this.overlay = true;
                this.overlayColor = "error";
                this.overlayText = "Cannot remove members from team";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }else{
                this.remove_dialog = true;
                this.remove_player.mid = player.mid;
                this.remove_player.lastname = player.lastname;
                this.remove_player.firstname = player.firstname;
            }
        },
        deletePosition: function(position) {
            this.remove_position_dialog = true;
            this.remove_position = position;
            if(position == 'coach'){
                this.remove_position_fullname = this.teamDetail.t_coach;
            }
            if(position == 'assistant'){
                this.remove_position_fullname = this.teamDetail.t_assistant;
            }
        },
        cancelRemovePosition: function() {
            this.remove_position_dialog = false;
            this.remove_position = '';
            this.remove_position_fullname = '';
        },
        sendRemovePosition: function(remove_position) {
            this.$store.dispatch("team/sendRemovePosition", { teamTid: this.teamTid, position: remove_position }).then(resp => {
                this.remove_position = '';
                this.remove_position_fullname = '';

                this.$store.dispatch("team/teamRequest");
                this.remove_position_dialog = false;

                this.overlay = true;
                this.overlayColor = "primary";
                this.overlayText = "Position removed successfully";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }).catch(err => {
                this.remove_position_dialog = false;

                this.overlay = true;
                this.overlayColor = "error";
                this.overlayText = "Position not removed";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        cancelRemovePlayer: function() {
            this.remove_dialog = false;
            this.remove_player.mid = '';
            this.remove_player.lastname = '';
            this.remove_player.firstname = '';
        },
        sendRemovePlayer: function(remove_player) {
            this.$store.dispatch("team/sendRemovePlayer", { teamTid: this.teamTid, playerMid: remove_player.mid }).then(resp => {
                this.remove_player.mid = '';
                this.remove_player.lastname = '';
                this.remove_player.firstname = '';

                this.$store.dispatch("team/teamRequest");
                this.remove_dialog = false;

                this.overlay = true;
                this.overlayColor = "primary";
                this.overlayText = "Member removed successfully";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }).catch(err => {
                this.remove_dialog = false;

                this.overlay = true;
                this.overlayColor = "error";
                this.overlayText = "Member not removed";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        emptyNewPlayers: function(e) {
            this.newplayers = [];
            this.add_dialog = false;
        },
        emptyNewTempPlayers: function(e) {
            this.newtempplayers = [];
            this.add_tempdialog = false;
        },
        sendNewTempPlayers: function(e){
            this.$store.dispatch("team/sendNewTempPlayers", { teamTid: this.teamTid, tempplayers: this.newtempplayers}).then(resp => {
                this.newtempplayers = [];
                this.add_tempdialog = false;

                this.overlaytemp = true;
                this.overlayColor = "primary";
                this.overlayText = "Temporary members request sent successfully";

                setTimeout(() => {
                    this.overlaytemp = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }).catch(err => {
                // this.newplayers = [];
                // this.add_dialog = false;

                this.overlaynewtemp = true;
                this.overlayColor = "error";
                this.overlayText = "Temporary members request not sent";

                setTimeout(() => {
                    this.overlaynewtemp = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        sendNewPlayers: function(e){
            this.$store.dispatch("team/sendNewPlayers", { teamTid: this.teamTid, players: this.newplayers}).then(resp => {
                this.newplayers = [];
                this.add_dialog = false;

                this.overlay = true;
                this.overlayColor = "primary";
                this.overlayText = "New members request sent successfully";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }).catch(err => {
                // this.newplayers = [];
                // this.add_dialog = false;

                this.overlaynew = true;
                this.overlayColor = "error";
                this.overlayText = "New members request not sent";

                setTimeout(() => {
                    this.overlaynew = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        sendGameForfeit: function(e){
            this.$store.dispatch("team/sendGameForfeit", { teamTid: this.teamTid, game: this.forfeitgame}).then(resp => {
                this.forfeitgame = '';
                this.forfeit_dialog = false;

                this.overlay = true;
                this.overlayColor = "primary";
                this.overlayText = "Game forfeited successfully";

                setTimeout(() => {
                    this.overlay = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            }).catch(err => {
                this.overlayforfeitnew = true;
                this.overlayColor = "error";
                this.overlayText = "Game not forfeited";

                setTimeout(() => {
                    this.overlayforfeitnew = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            });
        },
        addNewPlayer: function(e) {
            if((_.size(this.teamDetail.t_players) + _.size(this.newplayers)) >= this.teamDetail.t_division_max_players){
                this.overlaynew = true;
                this.overlayColor = "error";
                this.overlayText = "Cannot add more members to team";

                setTimeout(() => {
                    this.overlaynew = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            } else {
                e.preventDefault();
                this.newplayers.push({
                    firstname: "",
                    lastname: "",
                    dob: "",
                    gender: "",
                    role: "player",
                    email: "",
                    mid: "",
                    rep: false,
                    requireEmail: false,
                    status: "",
                    btn: "ADD NEW MEMBER",
                    confirm: false,
                    click: false,
                    copied: false,
                });
            }
        },
        addNewTempPlayer: function(e) {
            if((_.size(this.newtempplayers)) >= 3){
                this.overlaynewtemp = true;
                this.overlayColor = "error";
                this.overlayText = "Cannot add more temporary members to team for game selected";

                setTimeout(() => {
                    this.overlaynewtemp = false;
                    this.overlayColor = '';
                    this.overlayText = '';
                }, this.timeout);
            } else {
                e.preventDefault();
                this.newtempplayers.push({
                    firstname: "",
                    lastname: "",
                    dob: "",
                    gender: "",
                    email: "",
                    mid: "",
                    rep: false,
                    replacing: this.teamplayers[0].mid,
                    requireEmail: false,
                    status: "",
                    btn: "ADD TEMPORARY MEMBER",
                    confirm: false,
                    click: false,
                    copied: false,
                });
            }
        },
        removeNewPlayer: function(index_newplayer) {
            this.newplayers.splice(index_newplayer, 1);
            this.overlaynew = true;
            this.overlayText = "New Member removed successfully";
            this.overlayColor = "primary";

            setTimeout(() => {
                this.overlaynew = false;
            }, this.timeout);
        },
        removeNewTempPlayer: function(index_newtempplayer) {
            this.newtempplayers.splice(index_newtempplayer, 1);
            this.overlaynewtemp = true;
            this.overlayText = "Temporary Member removed successfully";
            this.overlayColor = "primary";

            setTimeout(() => {
                this.overlaynew = false;
            }, this.timeout);
        },
        checkNewPlayer: function(index_newplayer) {
            if (this.newplayers[index_newplayer].firstname && this.newplayers[index_newplayer].lastname && ((this.newplayers[index_newplayer].dob && this.newplayers[index_newplayer].gender) || this.newplayers[index_newplayer].mid)) {
                let newplayerData = this.newplayers;
                let hasDuplicateNewPlayer = _.size(
                    _.filter(this.newplayers.concat(this.teamDetail.t_players), function(o_n) {
                        return o_n.firstname == newplayerData[index_newplayer].firstname && o_n.lastname == newplayerData[index_newplayer].lastname;
                    })
                );
                if (hasDuplicateNewPlayer <= 1) {
                    this.$store
                        .dispatch("teamnomination/checkPlayer", { player: this.newplayers[index_newplayer], division: this.teamDetail.t_division_id, fromteamentry: false })
                        .then(resp => {
                            this.newplayers[index_newplayer].confirm = true;
                            this.newplayers[index_newplayer].click = true;
                            // this.newplayers[index_newplayer].requireEmail = false;
                            this.newplayers[index_newplayer].status = resp.data;
                            this.newplayers[index_newplayer].btn = "NEW MEMBER ADDED";

                            this.overlaynew = true;
                            this.overlayColor = "primary";
                            this.overlayText = "New Member added successfully";

                            setTimeout(() => {
                                this.overlaynew = false;
                            }, this.timeout);
                        })
                        .catch(err => {
                            this.newplayers[index_newplayer].click = true;
                            this.newplayers[index_newplayer].requireEmail = false;
                            this.newplayers[index_newplayer].confirm = false;

                            if (err == "Email required") {
                                this.newplayers[index_newplayer].requireEmail = true;
                            }

                            this.newplayers[index_newplayer].status = err;
                        });
                } else {
                    this.overlaynew = true;
                    this.overlayText = "Member already exist or added to the team";
                    this.overlayColor = "error";
                }
            }
        },
        checkNewTempPlayer: function(index_newtempplayer) {
            if (this.newtempplayers[index_newtempplayer].firstname && this.newtempplayers[index_newtempplayer].lastname && ((this.newtempplayers[index_newtempplayer].dob && this.newtempplayers[index_newtempplayer].gender) || this.newtempplayers[index_newtempplayer].mid)) {
                let newtempplayerData = this.newtempplayers;
                let hasDuplicateNewPlayer = _.size(
                    _.filter(this.newtempplayers.concat(this.teamDetail.t_players), function(o_n) {
                        return o_n.firstname == newtempplayerData[index_newtempplayer].firstname && o_n.lastname == newtempplayerData[index_newtempplayer].lastname;
                    })
                );
                if (hasDuplicateNewPlayer <= 1) {
                    this.$store
                        .dispatch("teamnomination/checkPlayer", { player: this.newtempplayers[index_newtempplayer], division: this.teamDetail.t_division_id, fromteamentry: false })
                        .then(resp => {
                            this.newtempplayers[index_newtempplayer].confirm = true;
                            this.newtempplayers[index_newtempplayer].click = true;
                            // this.newtempplayers[index_newtempplayer].requireEmail = false;
                            this.newtempplayers[index_newtempplayer].status = resp.data;
                            this.newtempplayers[index_newtempplayer].btn = "TEMPORARY MEMBER ADDED";

                            this.overlaynew = true;
                            this.overlayColor = "primary";
                            this.overlayText = "Temporary Member added successfully";

                            setTimeout(() => {
                                this.overlaynew = false;
                            }, this.timeout);
                        })
                        .catch(err => {
                            this.newtempplayers[index_newtempplayer].click = true;
                            this.newtempplayers[index_newtempplayer].requireEmail = false;
                            this.newtempplayers[index_newtempplayer].confirm = false;

                            if (err == "Email required") {
                                this.newtempplayers[index_newtempplayer].requireEmail = true;
                            }

                            this.newtempplayers[index_newtempplayer].status = err;
                        });
                } else {
                    this.overlaynew = true;
                    this.overlayText = "Temporary Member already exist or added to the team";
                    this.overlayColor = "error";
                }
            }
        },
        getPlayersNumber(mid){
           return this.playersNumber[mid];
        },
        // changeColour(type){
        //     console.log(type);
        // },
        playingNumber(value, mid){
            this.playersNumber[mid] = value;
        },
        saveTeam(){
            // console.log(this.singletColour, this.numberColour, this.playersNumber, this.teamTid);
            let arrayObj = Object.entries(this.playersNumber).map((arr) => ({
                mid: arr[0],
                number: arr[1],
            }));

            this.$store
                .dispatch("team/saveTeam", {
                    singletColour: this.singletColour,
                    numberColour: this.numberColour,
                    playersNumber: JSON.stringify(arrayObj),
                    teamTid: this.teamTid,
                })
                .then(() => {
                    this.overlayText = "Team detail saved successful.";
                    this.overlay = true;
                    this.overlayColor = "primary";

                    setTimeout(() => {
                        this.overlay = false;
                    }, this.timeout);
                })
                .catch(err => {
                    this.overlayText = "Team detail incorrect.";
                    this.overlay = true;
                    this.overlayColor = "error";

                    setTimeout(() => {
                        this.overlay = false;
                    }, this.timeout);
                });
        },
        total(payments) {
            let sum = parseFloat(0.0);
            return payments.reduce(function(sum, payment) {
                let discount = !_.isNil(payment.p_discount) ? payment.p_discount : 0.0;
                let amount = payment.p_amount;

                if (payment.p_refunded) {
                    amount = payment.p_amount * -1;
                }

                return sum + parseFloat(amount) + parseFloat(discount);
            }, 0.0);
        },
        totalPayments(payments) {
            let sum = !_.isEmpty(payments) ? this.total(payments) : 0;
            return this.$options.filters.currency(sum);
        },
        owingPayments(total, payments) {
            let sum = !_.isEmpty(payments) ? this.total(payments) : 0;
            let owing = parseFloat(total) - parseFloat(sum);
            return this.$options.filters.currency(owing);
        },
        displayAmount(payment) {
            return payment.p_refunded ? payment.p_amount * -1 : payment.p_amount;
        },
        resetTeam: function() {
            if (!_.isEmpty(this.teams)) {
                let tId = this.teamTid;
                this.teamDetail = _.find(this.teams, function(tm) {
                    return tm.t_id == tId;
                });

                this.singletColour = this.teamDetail.t_singlet_colour ?? '';
                this.numberColour = this.teamDetail.t_number_colour ?? '';

                // console.log('first loaded');

                if (!_.isEmpty(this.teamDetail)) {
                    this.teamLoaded = true;

                    let playersNumberArr = [];
                    _.forEach(this.teamDetail.t_players, function(player) {
                        playersNumberArr[player.mid] = player.playing_number;
                    });
                    this.playersNumber = playersNumberArr;
                }
            }
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');
        // if(_.isEmpty(this.$store.getters['team/teams'])){
        this.$store.dispatch("team/teamRequest");
        // }
    },
    created() {
        this.resetTeam();
    },
    mounted() {
        if (_.isEmpty(this.teamDetail) && this.team !== undefined) {
            this.teamDetail = this.team;
            this.singletColour = this.teamDetail.t_singlet_colour;
            this.numberColour = this.teamDetail.t_number_colour;

            let playersNumberArr = [];
            _.forEach(this.teamDetail.t_players, function(player) {
                playersNumberArr[player.mid] = player.playing_number;
            });
            this.playersNumber = playersNumberArr;
            // console.log('cannot reach');
        }

        this.teamLoaded = true;
    },
};
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
[v-cloak] > * {
    display: none;
}

::v-deep .playerNumber .v-text-field__details {
    display: none !important;
}
::v-deep .playerNumber .v-input__slot {
    min-height: 20px !important;
    width: 90%;
    padding: 0 6px !important;
}

::v-deep .playerNumber .v-input__slot input {
    padding: 3px 0 !important;
    background: transparent !important;
}

::v-deep .playerNumber .v-input__prepend-outer {
    margin-top: 0px !important;
}

.forfeit {
    margin-top: 5px;
}

.features i.v-icon {
    font-size: 22px !important;
}

.mob_only {
    display: none;
}

.Ftable {
    $light-color: #ffffff;
    $header-color: #f8c689;
    $dark-color: #f2f2f2;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*border: 1px solid $dark-color;*/
    font-size: 1rem;
    padding: 0;
    margin: 0;
    line-height: 1.5;

    .Ftable__row {
        width: 100%;
        display: flex;

        &.Ftable__header {
            font-weight: bold;

            .Ftable__item {
                background: $header-color;
            }
        }

        .Ftable__item {
            flex: 1 1 25%;
            word-break: break-word;
            padding: 0.25em;
            border: 1px solid $light-color;
            background: $dark-color;

            input[type="text"] {
                width: 100%;
            }

            &.cols-2 {
                flex: 1 1 50%;
            }

            &.no-border {
                border: 0px solid $light-color;
            }

            &.right-border {
                border-right: 1px solid $light-color;
            }

            &.top-border {
                border-top: 1px solid $light-color;
            }

            &.bottom-border {
                border-bottom: 1px solid $light-color;
            }
        }
    }
}

@media only screen and (max-width: 767px) {
    ::v-deep .playerNumber .v-input__slot {
        min-height: 20px !important;
        width: 100%;
    }
    ::v-deep .playerNumber .v-input__prepend-outer {
        display: none !important;
    }

    .forfeit {
        margin: -5px 0 0px 10px;
    }

    .mob_only {
        display: block;
        font-size: 14px;
        line-height: 18px;
    }

    .Ftable.features .Ftable__row.Ftable__header {
        display: none;
    }

    .Ftable.features .Ftable__item.text-left.bottom-border {
        flex: 1 1 100%;
        width: 100%;
    }

    .Ftable.features .Ftable__row {
        flex-direction: column;
    }
}
</style>
